<div class="calendar-header">
  <button mat-icon-button (click)="previousMonth()" class="calendar-header-previous-month">
    <ion-icon name="chevron-back"></ion-icon>
  </button>
  <div class="header-label">{{periodLabel()}}</div>
  <button mat-icon-button (click)="nextMonth()" class="calendar-header-next-month">
    <ion-icon name="chevron-forward"></ion-icon>
  </button>
</div>
